// extracted by mini-css-extract-plugin
export default {"button":"a6TvzC"};